module.exports = __webpack_public_path__ + "assets/img/fullscreen.d0fe20db.png";